import React from 'react'
import { Modal } from 'react-bootstrap'

function VirtualTourModal({ handleClose, virtualTourURL, showVirtualTourModal }) {
    return (
        <Modal fullscreen
            show={showVirtualTourModal} onHide={handleClose}>
            <Modal.Header closeButton >
            </Modal.Header>
            <Modal.Body>
                <iframe width="100%" height="100%" allowtransparency="true" src={virtualTourURL}></iframe>
            </Modal.Body>
        </Modal>
    )
}

export default VirtualTourModal